import { createApp } from 'vue';
import Cr3ToJpgConverter from '../Components/Cr3ToJpgConverter.vue';

const root = document.getElementById('cr3-to-jpg-converter');
if (root) {
  createApp(Cr3ToJpgConverter).mount('#cr3-to-jpg-converter');
}
